export const entrepreneursEnrolledPerCountryChartCalculation = (props: any) => {
    const {uoas, projectsBreakdown} = props;
    let data: any = [];

    if (projectsBreakdown) {
        const countries = projectsBreakdown.levels
            .filter((level: any) => !level.parent_id);
        
        data = projectsBreakdown.levels
            .filter((level: any) => level.parent_id)
            .map((level: any) => ({
                name: countries.find((contry: any) => contry.id === level.parent_id).name,
                y: uoas.filter((uoa: any) => uoa.levels.includes(level.id)).length
            }));
    }

    return {
        chart: {
            type: 'column',
        },
        title: {
            text: 'Entrepreneurs enrolled per country',
            align: 'left',
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
        },
        xAxis: {
            categories: data.map((el: any) => el.name),
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
            },
        },
        series: [
            {
                showInLegend: false,
                name: 'Number',
                data: data.map((el: any) => el.y),
                type: 'column',
                dataLabels: {
                    enabled: true,
                },
            },
        ],
    };
}